import {findIndex} from 'lodash';
// @see https://vuetifyjs.com/en/styles/scroll/#api
import goTo from 'vuetify/es5/services/goto';
import veevaVaultService from '../../services/veevaVaultService';

const state = {
  connection: null,
  documents: [],
  folder: null,
  showInMainList: true, // MLD-3968
  labels: [],
  groups: [],
  importAll: false, // MLD-2686
  permissions: veevaVaultService.initPermissions(),
  settings: {
    synchronize_title: true,
    synchronize_expiration_date: true,
  },
  shareTemplateID: '',
  isTemplateRequired: false, // MLD-3997
  shareThemeID: '',
  step: 1,
  taskName: null,
}

const mutations = {
  reset(state, team) {
    state.connection = null;
    state.documents = [];
    state.folder = null;
    state.showInMainList = false; // MLD-3968
    state.labels = [];
    state.groups = [];
    state.importAll = false; // MLD-2686
    state.permissions = veevaVaultService.initPermissions(team);
    state.settings.synchronize_title = true;
    state.settings.synchronize_expiration_date = true;
    state.shareTemplateID = '';
    state.isTemplateRequired = false; // MLD-3997
    state.shareThemeID = '';
    state.step = 1;
    state.taskName = null;
  },
  setConnection(state, connection) {
    state.connection = connection;
  },
  setDocuments(state, documents) {
    state.documents = documents;
  },
  addDocument(state, document) {
    const index = findIndex(state.documents, d => d.id === document.id);
    if (index === -1) {
      state.documents.push(document);
    }
  },
  removeDocument(state, document) {
    state.documents = state.documents.filter(d => d.id !== document.id);
  },
  setFolder(state, folder) {
    state.folder = folder;
  },
  setShowInMainList(state, showInMainList) { // MLD-3968
    state.showInMainList = showInMainList;
  },
  setGroups(state, groups) {
    state.groups = groups;
  },
  setImportAll(state, importAll) { // MLD-2686
    state.importAll = importAll;
    console.log('importAll', importAll);
  },
  setLabels(state, labels) {
    state.labels = labels;
  },
  setPermissions(state, permissions) {
    state.permissions = permissions;
  },
  setShareTemplateID(state, shareTemplateID) {
    state.shareTemplateID = shareTemplateID;
  },
  setShareThemeID(state, shareThemeID) {
    state.shareThemeID = shareThemeID;
  },
  setIsTemplateRequired(state, isTemplateRequired) { // MLD-3997
    state.isTemplateRequired = isTemplateRequired;
  },
  setStep(state, step) {
    state.step = step;
  },
  setTaskName(state, taskName) {
    state.taskName = taskName;
  }
}

const getters = {
  cart: state => state,
  connection: state => state.connection,
  documents: state => state.documents,
  folder: state => state.folder,
  showInMainList: state => state.showInMainList, // MLD-3968
  groups: state => state.groups,
  importAll: state => state.importAll, // MLD-2686
  labels: state => state.labels,
  permissions: state => state.permissions,
  step: state => state.step,
  shareTemplateID: state => state.shareTemplateID,
  isTemplateRequired: state =>state.isTemplateRequired, // MLD-3997
  shareThemeID: state => state.shareThemeID,
  taskName: state => state.taskName,
}

const actions = {
  reset({commit}) {
    commit('reset');
  },
  setConnection({commit}, connection) {
    commit('setConnection', connection);
  },
  addDocument({commit, getters}, document) {
    commit('addDocument', document);
  },
  addDocuments({commit, dispatch}, documents) {
    documents.forEach(document => {
      commit('addDocument', document);
    })
  },
  removeDocument({commit, getters}, document) {
    commit('removeDocument', document);
  },
  removeAll({commit}) {
    commit('setDocuments', []);
  },
  setFolder({commit}, folder) {
    commit('setFolder', folder);
  },
  setShowInMainList({commit}, showInMainList) { // MLD-3968
    commit('setShowInMainList', showInMainList)
  },
  setGroups({commit}, groups) {
    commit('setGroups', groups);
  },
  setImportAll({commit}, importAll) { // MLD-2686
    commit('setImportAll', importAll);
  },
  setLabels({commit}, labels) {
    commit('setLabels', labels);
  },
  setPermissions({commit}, permissions) {
    commit('setPermissions', permissions);
  },
  setShareTemplateID({commit}, shareTemplateID) {
    commit('setShareTemplateID', shareTemplateID);
  },
  setIsTemplateRequired({commit}, isTemplateRequired) { // MLD-3997
    commit('setIsTemplateRequired', isTemplateRequired);
  },
  setShareThemeID({commit}, shareThemeID) {
    commit('setShareThemeID',shareThemeID);
  },
  setStep({commit}, step) {
    commit('setStep', step);
  },
  prevStep({commit, getters}) {
    if (getters.step > 1) {
      commit('setStep', getters.step - 1);
      goTo(0, { easing: 'easeInOutCubic', duration: 300}); // MLD-3968
    }
  },
  nextStep({commit, getters}) {
    if (getters.step < 9) {
      commit('setStep', getters.step + 1);
      goTo(0, { easing: 'easeInOutCubic', duration: 300}); // MLD-3968
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
